import { useContext, useEffect, useState } from "react";
import { useParams, Link, Navigate, useNavigate, useLocation } from "react-router-dom";
import { Container, Card, Button, Row, Col, Image } from "react-bootstrap";
import { DarshanBook_TempleList } from "../../ApiServices/Darshan Booking/DarshanBookingApi";
import LoginPopUp from "../LoginPopup";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import { GetTempleRegistrationDetailsBySlug } from "../../ApiServices/SlugsApi/GetTempleRegistrationDetailsBySlugApi";
import { Helmet } from "react-helmet-async";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { GetFAQListByService } from "../../ApiServices/FAQ/FAQApi";
import { FaqModuleID } from "../enum";
// API function (replace this with your actual function)
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import ShareLinkModal from "../ShareLinkModal";
import { DarshanShareMassage } from "../../middlewares/Utils";
const TempleDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Get temple ID from URL
  const [loginPopUp, setLoginPopUp] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const currentUrl = window.location.href;

  const { setLoader } = useContext(LoaderContext);
  const [temple, setTemple] = useState({
    TR_ADDRESS: null,
    TR_NAME: null,
    DARSHAN_TIME: null,
    CONVENIENCE_FEE: null,
    LATITUDE: null,
    LONGITUDE: null,
    TR_DETAILS: null,
    TR_IMAGE: null,
    SEATING_CAPACITY: null,
    TR_SHORTDETAILS: null,
    DARSHAN_PRICE: null,
    CONVENIENCE_FEE: null,
    ConvinienceFeeTaxPercent: null,
    ConvinienceFeeTaxAmount: null,
    ConvinienceFeeTaxPercent: null,
    TempleSlug: null,
    MetaTitle: null,
    MetaDescription: null,
    OpenGraphtag: null,
    CanonicalTag: null,
    ExtraMetaTag: null,
    ShortDescription: null,
    KeyFeature: null,
    TempleSlug: null,
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const { isAuthenticated } = useContext(AuthContextProvider);
  const { slug } = useParams();
  const [FAQ, setFaq] = useState([]);
  const location = useLocation()
  const [modelRequestData, setModelRequestData] = useState({
    Action: null,
    DARSHAN_PRICE: null,
    DARSHAN_TIME: null,
    TR_ID: null,
    CONVENIENCE_FEE: null,
    TR_SHORTDETAILS: null,
  });

  useEffect(() => {
    fetchTempleDetails();
  }, [location]);

  const fetchTempleDetails = async () => {
    const userID = localStorage.getItem("userID") || "";
    setLoading(true);
    const params = {
      START: 0,
      END: 10,
      WORD: "None",
      LATITUDE: "20.008581",
      LONGITUDE: "73.76413099999999",
    };

    try {
      const response = await GetTempleRegistrationDetailsBySlug(slug);
      if (
        response.ResponseCode === "0" &&
        response.ResponseMessage === "list"
      ) {
        setLoading(false);
        const Data = response.DATA[0];
        if (!Data) {
          navigate("/*");
          return;
        }
        setTemple(Data);
        GetFAQListByServiceData(Data?.TR_ID);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching temple details:", error);
    }
  };

  const GetFAQListByServiceData = async (PujaID) => {
    // debugger;
    setLoader(true);
    try {
      const response = await GetFAQListByService(
        FaqModuleID?.DarshanBooking,
        PujaID
      );

      if (response) {
        setLoader(false);
        const modalData = response.DATA;
        console.log(modalData);
        setFaq(modalData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (loading) {
    return <div className="text-center mt-5">Loading temple details...</div>;
  }

  if (!temple) {
    return <div className="text-center mt-5">Temple not found.</div>;
  }

  const clickToBook = (temple) => {
    console.log(temple, "ddddddddddds33");

    {
      setModelRequestData({
        ...modelRequestData,
        Action: null,
        DARSHAN_PRICE: temple.DARSHAN_PRICE,
        DARSHAN_TIME: temple.DARSHAN_TIME,
        TR_ID: temple.TR_ID,
        CONVENIENCE_FEE: temple.CONVENIENCE_FEE,
        TR_SHORTDETAILS: temple.TR_SHORTDETAILS,

        BEST_SEASON: temple.BEST_SEASON,
        CONVENIENCE_FEE: temple.CONVENIENCE_FEE,
        DARSHAN_PRICE: temple.DARSHAN_PRICE,
        DARSHAN_TIME: temple.DARSHAN_TIME,
        LATITUDE: temple.LATITUDE,
        LONGITUDE: temple.LONGITUDE,
        Row: temple.Row,
        SEATING_CAPACITY: temple.SEATING_CAPACITY,
        TR_ADDRESS: temple.TR_ADDRESS,
        TR_DETAILS: temple.TR_DETAILS,
        TR_ID: temple.TR_ID,
        TR_IMAGE: temple.TR_IMAGE,
        TR_NAME: temple.TR_NAME,
        TR_RULES: temple.TR_RULES,
        TR_SHORTDETAILS: temple.TR_SHORTDETAILS,
      });
    }
    let addRawMaterialRequestData = {
      Action: null,
      DARSHAN_PRICE: temple.DARSHAN_PRICE,
      DARSHAN_TIME: temple.DARSHAN_TIME,
      TR_ID: temple.TR_ID,
      CONVENIENCE_FEE: temple.CONVENIENCE_FEE,
      TR_SHORTDETAILS: temple.TR_SHORTDETAILS,
      BEST_SEASON: temple.BEST_SEASON,
      CONVENIENCE_FEE: temple.CONVENIENCE_FEE,
      DARSHAN_PRICE: temple.DARSHAN_PRICE,
      DARSHAN_TIME: temple.DARSHAN_TIME,
      LATITUDE: temple.LATITUDE,
      LONGITUDE: temple.LONGITUDE,
      Row: temple.Row,
      SEATING_CAPACITY: temple.SEATING_CAPACITY,
      TR_ADDRESS: temple.TR_ADDRESS,
      TR_DETAILS: temple.TR_DETAILS,
      TR_ID: temple.TR_ID,
      TR_IMAGE: temple.TR_IMAGE,
      TR_NAME: temple.TR_NAME,
      TR_RULES: temple.TR_RULES,
      TR_SHORTDETAILS: temple.TR_SHORTDETAILS,
      Action: null,
    };
    if (isAuthenticated) {
      navigate("/temple-booking-form", { state: temple });
    } else {
      setLoginPopUp(true);
    }
  };
  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount?.toString()?.split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }
  const FaqObj = [
    {
      question: "What services does Myomnamo offer?",
      answer:
        "Myomnamo offers a range of spiritual services, including Puja and Darshan bookings. You can book experienced Pandits for rituals or arrange daily pujas. Our E-Store provides access to religious goods, and Puja samgari, puja kits. Additionally, Myom namo offers horoscope services.",
      color: "#ffa415",
    },
    {
      question: "Can I schedule a temple visit through My OmNamo?",
      answer:
        "Yes, Myomnamo allows you to book temple visits online for your convenience. You can easily select your preferred temple, date, and time through our app. My Om Namo specializes in offering customized puja packages and online Darshans.",
      color: "#fc5528",
    },
    {
      question: "Can I book personalized consultations with spiritual mentors?",
      answer:
        "Yes, Myomnamo provides a platform to book personalized consultations with experienced spiritual mentors. You can connect with mentors who can offer guidance and support on your spiritual journey. These sessions can provide personalized advice and practices tailored to your specific needs",
      color: "#8139e7",
    },
    // {
    //   question: "Why is it important How Volunteer?",
    //   answer:
    //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
    //   color: "#399be7",
    // },
  ];
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": temple?.MetaTitle,
    "description": temple?.MetaDescription,
    "image": temple?.imageURL || "default-image-url.jpg",
    "author": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.myomnamo.com"
      }
    },
    "datePublished": temple?.publishedDate || null,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": temple?.CanonicalTag
    }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": temple?.MetaTitle,
    "description": temple?.MetaDescription,
    "url": temple?.canonicalURL,
    "image": temple?.imageURL || "default-image-url.jpg",
    "inLanguage": "en",
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": `https://www.myomnamo.com/services/book-puja/${temple?.TempleSlug}`
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.myomnamo.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Temple List",
        "item": "https://www.myomnamo.com/darshan-booking"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": temple?.MetaTitle,
        "item": temple?.canonicalURL
      }
    ]
  };
  return (
    <div className="PujaDetails">
      <Helmet>
        <title>{temple?.MetaTitle}</title>
        <meta name="description" content={temple?.MetaDescription} />
        <link rel="canonical" href={temple?.CannonicalLink} />

        {/* Open Graph Tag */}

        {/* <!-- Open Graph tags --> */}
        <meta property="og:title" content={temple?.MetaTitle} />
        <meta property="og:description" content={temple?.MetaDescription} />
        <meta property="og:image" content="" />
        <meta
          property="og:url"
          content={`https://www.myomnamo.com/services/book-puja/${temple?.TempleSlug}`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="MyOmNamo" />
        <meta property="og:locale" content="en_IN" />

        {/* <!-- Twitter Card tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={temple?.MetaTitle} />
        <meta name="twitter:description" content={temple?.MetaDescription} />
        <meta name="twitter:image" content="" />
        {temple?.ExtraMetaTag}

        {/* Breadcrumb JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>

        {/* WebPage JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(articleSchema)}
        </script>
      </Helmet>
      <div className="PujaDetailsContainer">
        <div className="puja-summary-section">
          <div className="left-puja-details">
            <img
              src={temple.TR_IMAGE || placeholderImg}
              alt="Puja-Img"
              className="puja-img"
            />
          </div>
          <div className="right description-container">
            <div className="puja-header">
              <div
                style={{
                  justifyContent: "end",
                  display: "flex",
                  width: "100%",
                }}
              >
                <button
                  className="pujacustom-btn Normal-app-btn d-none d-lg-block d-md-block"
                  onClick={() => clickToBook(temple)}
                >
                  Proceed to Book
                </button>
              </div>
              <h1> {temple.TR_NAME}</h1>
            </div>

            {/* Pricing Section */}
            <div className="d-flex d-lg-none d-md-none mb-1 justify-content-center">
              <button

                className="btn btn-block Normal-app-btn w-80"
                onClick={() => clickToBook(temple)}
              >
                Proceed to Book
              </button>
            </div>
            <div
              className="price-tag d-flex"

            >
              <div className="discounted-price ">
                <strong>
                  ₹ {formatToIndianCurrency(temple?.DARSHAN_PRICE)}/person
                </strong>

              </div>
              <button
                className=" custom-share-btn"
                onClick={() => setShowModal(true)}
                title="Share"
              >
                <i className="fa-solid fa-up-right-from-square mx-1"></i>
                Share
              </button>
            </div>

            {/* Short Description */}
            <div className="description">
              <div>
                <ul>
                  <li>
                    <strong>Location:</strong> {temple.TR_ADDRESS}{" "}
                    <span>
                      <a
                        href={`https://www.google.com/maps?q=${temple.LATITUDE},${temple.LONGITUDE}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#8f3246] hover:text-[#a9445d] px-2"
                      >
                        <i className="fa fa-map-marker" aria-hidden="true"></i>
                      </a>
                    </span>
                  </li>
                  <li>
                    <strong>Darshan Capacity:</strong> {temple.SEATING_CAPACITY}
                  </li>
                  <li>
                    {" "}
                    <strong>Best Season:</strong>{" "}
                    {temple.BEST_SEASON || "Anytime"}
                  </li>
                  <li>
                    {" "}
                    <strong>Rules:</strong> {temple.TR_RULES}
                  </li>
                </ul>
              </div>
              {temple?.TR_SHORTDETAILS && (
                <div
                  dangerouslySetInnerHTML={{ __html: temple?.TR_SHORTDETAILS }}
                />
              )}
            </div>

            {/* Samagri / Features */}
            <div className="samagri">
              {temple?.KeyFeature && <h5>Key Features</h5>}
              <div dangerouslySetInnerHTML={{ __html: temple?.KeyFeature }} />
            </div>
          </div>
        </div>
        {/* Description Section */}
        <div className="detailed-description">
          {temple.TR_DETAILS && <h5>Description</h5>}

          <div dangerouslySetInnerHTML={{ __html: temple.TR_DETAILS }} />
        </div>

        {/* FAQ Section */}
        {FAQ?.length > 0 && (
          <div className="faq-section">
            <section className="faq-one faq-one--page">
              <div
                className="container"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div className="sec-title text-center">
                  <h6
                    className="sec-title__tagline bw-split-in-right"
                    style={{
                      perspective: "400px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/* <img className=" tagline-img" src={batuk} alt="" /> FAQ */}
                    <img className=" tagline-img" src={batuk} alt="" /> FAQs
                    {/* <span className="sec-title__tagline__border"></span> FAQ */}
                  </h6>
                  <h3
                    className="sec-title__title bw-split-in-left"
                    style={{ perspective: "400px", textAlign: "center" }}
                  >
                    Frequently Asked Questions.
                  </h3>
                </div>
                <div className="row">
                  <div className="col-xl-2"></div>
                  <div className="col-xl-8">
                    <div className="faq-one__accordion careox-accordion">
                      {FAQ?.map((faq, index) => (
                        <div
                          key={index}
                          className={`accrodion ${activeIndex === index ? "active" : ""
                            }`}
                          style={{ "--accent-color": faq.color }}
                        >
                          <div
                            className="accrodion-title"
                            onClick={() => toggleFAQ(index)}
                          >
                            <h4>
                              <span
                                className="accrodion-title__number"
                                style={{
                                  marginRight: "10px",
                                  fontWeight: "500",
                                }}
                              ></span>
                              {faq.QUESTION}
                              <span className="accrodion-title__icon"></span>
                            </h4>
                          </div>
                          <div
                            className="accrodion-content"
                            style={{
                              maxHeight: activeIndex === index ? "200px" : "0",
                              overflow: "hidden",
                              transition: "max-height 0.5s ease-in-out",
                            }}
                          >
                            <div className="inner">
                              <p>{faq.ANSWER}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-xl-2"></div>
                </div>
              </div>
            </section>
          </div>
        )}
      </div>
      {loginPopUp && (
        <LoginPopUp show={loginPopUp} onHide={() => setLoginPopUp(false)} />
      )}
      <ShareLinkModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        shareUrl={currentUrl}
        message={DarshanShareMassage} // Optional
        title="Spread the word" // Optional
      />
    </div>
  );
};

export default TempleDetails;
